var _path, _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5497 8.33028C20.5314 9.78134 21.8325 10.5911 22.8126 11.0726C23.8196 11.5666 24.1579 11.8834 24.154 12.3251C24.1463 13.0012 23.3507 13.2995 22.606 13.3112C21.3069 13.3315 20.5516 12.9576 19.951 12.6748L19.4831 14.8823C20.0856 15.1623 21.2012 15.4064 22.3581 15.4171C25.0736 15.4171 26.8503 14.0658 26.8599 11.9705C26.8705 9.31154 23.2114 9.1643 23.2364 7.97575C23.245 7.6154 23.5861 7.23084 24.3337 7.133C24.7037 7.0836 25.7251 7.04582 26.883 7.58343L27.3375 5.44752C26.7148 5.21892 25.9144 5 24.9179 5C22.3619 5 20.5641 6.36969 20.5497 8.33028ZM31.7047 5.18402C31.2089 5.18402 30.7909 5.47559 30.6045 5.92312L26.7253 15.2601H29.4389L29.979 13.7558H33.295L33.6083 15.2601H36L33.9129 5.18402H31.7047ZM32.0843 7.90602L32.8674 11.6896H30.7227L32.0843 7.90602ZM17.2595 5.18402L15.1205 15.2601H17.7063L19.8443 5.18402H17.2595ZM13.4341 5.18402L10.7427 12.0422L9.65395 6.21081C9.52615 5.55987 9.02168 5.18402 8.46147 5.18402H4.0615L4 5.47656C4.90325 5.67417 5.92949 5.99286 6.5512 6.33383C6.93172 6.5421 7.0403 6.72421 7.16522 7.2192L9.22731 15.2601H11.9601L16.1497 5.18402H13.4341Z",
    fill: "url(#visa-linear)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "visa-mask",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 32,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5497 8.33028C20.5314 9.78134 21.8325 10.5911 22.8126 11.0726C23.8196 11.5666 24.1579 11.8834 24.154 12.3251C24.1463 13.0012 23.3507 13.2995 22.606 13.3112C21.3069 13.3315 20.5516 12.9576 19.951 12.6748L19.4831 14.8823C20.0856 15.1623 21.2012 15.4064 22.3581 15.4171C25.0736 15.4171 26.8503 14.0658 26.8599 11.9705C26.8705 9.31154 23.2114 9.1643 23.2364 7.97575C23.245 7.6154 23.5861 7.23084 24.3337 7.133C24.7037 7.0836 25.7251 7.04582 26.883 7.58343L27.3375 5.44752C26.7148 5.21892 25.9144 5 24.9179 5C22.3619 5 20.5641 6.36969 20.5497 8.33028ZM31.7047 5.18402C31.2089 5.18402 30.7909 5.47559 30.6045 5.92312L26.7253 15.2601H29.4389L29.979 13.7558H33.295L33.6083 15.2601H36L33.9129 5.18402H31.7047ZM32.0843 7.90602L32.8674 11.6896H30.7227L32.0843 7.90602ZM17.2595 5.18402L15.1205 15.2601H17.7063L19.8443 5.18402H17.2595ZM13.4341 5.18402L10.7427 12.0422L9.65395 6.21081C9.52615 5.55987 9.02168 5.18402 8.46147 5.18402H4.0615L4 5.47656C4.90325 5.67417 5.92949 5.99286 6.5512 6.33383C6.93172 6.5421 7.0403 6.72421 7.16522 7.2192L9.22731 15.2601H11.9601L16.1497 5.18402H13.4341Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#visa-mask)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "visa-linear",
    x1: 4.05578,
    y1: 8.204,
    x2: 13.1009,
    y2: -4.53474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#254AA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.187d6411.svg";
export { ForwardRef as ReactComponent };